/**
 * Parses optional structured extras from assistant text:
 *   SUGGESTIONS: … | …
 *   RECOMMENDATION: product | body part | why
 *
 * Order: strip recommendation first, then suggestions, so either (or both) can appear.
 * Suggestion chips are painted in the homepage composer tray, not under bubbles.
 * This module only extracts the chip labels so the catalog slice can share one parser.
 */

import { parseRecommendation } from "./recommendationCard";

const SUGGESTIONS_LINE =
  /(?:^|\n)\s*[`*_]*SUGGESTIONS[`*_]*:[`*_]*\s*([^\n]+)\s*(?:\n|$)/i;

/**
 * @param {string} [rawText]
 */
function parseSuggestionChips(rawText) {
  const text = (rawText || "").toString();
  const match = text.match(SUGGESTIONS_LINE);

  if (!match) {
    return { displayText: text, suggestions: [] };
  }

  const suggestions = match[1]
    .split("|")
    .map((chip) => chip.trim())
    .filter((chip) => chip.length > 0);

  return {
    displayText: text.replace(SUGGESTIONS_LINE, "\n").trimEnd(),
    suggestions,
  };
}

/**
 * @param {string} [rawText]
 * @param {{ products?: Record<string, any> | null, aliases?: Record<string, string> } | null} [catalog]
 */
export function parseAssistantPayload(rawText, catalog = null) {
  const products = catalog?.products ?? null;
  const aliases = catalog?.aliases ?? {};
  const withRecommendation = parseRecommendation(rawText, {
    products,
    aliases,
  });
  const withSuggestions = parseSuggestionChips(withRecommendation.displayText);

  return {
    displayText: withSuggestions.displayText,
    suggestions: withSuggestions.suggestions,
    recommendation: withRecommendation.recommendation,
  };
}
